var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 31.067l-12.267-12.2c1.8-2 2.867-4.6 2.867-7.533 0-6.267-5.067-11.333-11.333-11.333-6.2 0.067-11.267 5.133-11.267 11.333 0 6.267 5.067 11.333 11.333 11.333 2.867 0 5.533-1.067 7.533-2.867l12.2 12.2 0.933-0.933zM1.267 11.333c0-5.533 4.467-10 10-10s10 4.467 10 10-4.467 10-10 10c-5.467 0.067-10-4.467-10-10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fb0327de703da88e9dd3f067a277d06c.svg";
export { ForwardRef as ReactComponent };